import Image from "next/image";
import { t } from "@/lib/localization";

export default function EmptyState() {
    return (
        <div className="flex-1 h-full min-h-full my-auto flex p-6 gap-8 flex-col items-center justify-center">
            <Image
                src="/illustrations/user-infront-screen.svg"
                height={183} // 244
                width={394.5} // 526
                alt="empty state"
            />
            <div className="flex flex-col gap-0.5 justify-center items-center">
                <h3 className="text-lg sm:text-xl font-semibold">
                    {t("storage.overview-tab.empty-state.title", undefined, undefined)}
                </h3>
                <p className="text-sm sm:text-base text-gray-700 text-center">
                    {t("storage.overview-tab.empty-state.subtitle", undefined, undefined)}
                </p>
            </div>
        </div>
    );
}
